import { useCallback } from 'react';
import { toast } from 'react-toastify';
import { useQueryCache } from 'react-query';

import { offersActivate, offersDeactivate } from 'api/offerApi';

const useToggleOfferActive = (
	isActive: boolean,
	id: string,
	isRecruiter?: boolean,
) => {
	const cache = useQueryCache();

	return useCallback(async () => {
		if (
			isActive &&
			!window.confirm(
				`Určitě chcete nabídku deaktivovat?${
					isRecruiter
						? ' Deaktivací nabídky přijdete o jeden vypsaný inzerát z balíčku.'
						: ''
				}`,
			)
		) {
			return;
		}
		const response = await (isActive
			? offersDeactivate(id)
			: offersActivate(id));

		if (!response) {
			toast.error(
				`Nabídku se nepodařilo ${
					isActive
						? 'deaktivovat.'
						: 'aktivovat. Ujistěte se, že je dostatečně vyplněna a že vám také zůstávají zveřejnění.'
				}`,
			);
			return;
		}

		cache.invalidateQueries(['offers', 'logged-in-company']);
		cache.invalidateQueries(['offers/dto', id]);
		cache.invalidateQueries(['logged-in-company']);
		toast.success(
			`Nabídka úspěšně ${isActive ? 'deaktivována' : 'aktivována'}`,
		);
	}, [cache, isActive, id, isRecruiter]);
};

export default useToggleOfferActive;
